<template>
  <div class="donga-audit">
    <admin-header></admin-header>
    <div class="audit-template admin-template">
      <admin-aside></admin-aside>
      <div class="admin-container">
        <h2 class="contents-tit">회사 그룹권한 관리</h2>
        <div class="admin-manage-btn-top">
            <button type="button" class="sysadmin-default-btn" @click="showModal=true">생성</button>
        </div>
        <section class="admin-contents">
          <div class="card-body">
            <table class="card-table">
              <caption>회사 그룹권한 관리</caption>
              <colgroup>
                <col style="width:5%">
                <col style="width:30%">
                <col style="width:15%">
                <col style="width:15%">
                <col style="width:30%">
                <col style="width:5%">
              </colgroup>
              <tr>
                <th>순서</th>
                <th>회사명</th>
                <th>제보공유 메일발송 대상</th>
                <th>제보공유 메일수신 대상</th>
                <th>소속 그룹</th>
                <th>상태</th>
              </tr>
              <tr>
              </tr>
              <tr v-for="(item, index) in this.getSysadminCompanyTypeMaps" v-bind:key="index" @click="fnModify(item)">
                  <td>{{ item.orderSeq }}</td>
                  <td>{{ item.companyName }}</td>
                  <td><input type="checkbox" class="admin-checkbox" name="sourceTarget" :checked="item.isSourceComp" onclick="return false;"></td>
                  <td><input type="checkbox" class="admin-checkbox" name="destTarget" :checked="item.isDestinationComp" onclick="return false;"></td>
                  <td>{{ item.userGroupName }}</td>
                  <td>{{ item.statusTitle }}</td>
                  <td></td>
              </tr>
            </table>
          </div>
        </section>
        <modal v-if="showModal" @close="showModal=false">
            <h3 slot="body">
                <div class="form-modal-container">
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-orderseq">순서 *</label>
                        <input
                            v-model.trim="orderSeq"
                            class="default-input form-input"
                            type="text"
                            id="report-orderseq"
                            placeholder="순서">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-companyname">회사명 *</label>
                        <input
                            v-model.trim="companyName"
                            class="default-input form-input"
                            type="text"
                            id="report-companyname"
                            placeholder="메뉴명">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-srccomp">제보공유 메일발송 대상</label>
                          <input type="checkbox" class="admin-checkbox" v-model.trim="isSourceComp">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                        <label class="form-label" for="report-srccomp">제보공유 메일수신 대상</label>
                          <input type="checkbox" class="admin-checkbox" v-model.trim="isDestinationComp">
                        </div>
                    </div>
                    <div class="form-modal">
                        <div class="input-area">
                            <label class="form-label" for="report-status">그룹</label>
                            <select name="state-select" id="state-select" class="default-select" v-model.trim="userGroupId">
                                <option value="" v-if="flag === 'C'">그룹 선택</option>
                                <option v-for="(type) in this.getGroupsCombo" v-bind:key="type.title" v-bind:value="type.code">
                                {{ type.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <div class="form-modal" v-if="flag === 'U'">
                        <div class="input-area">
                            <label class="form-label" for="report-status">사용여부</label>
                            <select name="state-select" id="state-select" class="default-select" v-model.trim="statusCode">
                                <option v-for="(type) in this.getStatuses" v-bind:key="type.title" v-bind:value="type.code">
                                {{ type.title }}
                                </option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="modal-btn-area">
                  <button type="button" class="modal-btn-save" @click="save()">저장</button>
                  <button type="button" class="modal-btn-cancle" @click="cancle()">닫기</button>
                </div>
            </h3>
        </modal>
      </div>
    </div>
    <admin-footer></admin-footer>
  </div>
</template>

<style lang="scss" scoped>
@import '../css/sub.scss';
@import '../css/admin.scss';
</style>

<script>
import AdminHeader from '@/components/AdminHeader'
import AdminFooter from '@/components/AdminFooter'
import AdminAside from '@/components/AdminAside'
import Modal from '@/components/AdminModal'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AdminCompanyAuth',
  components: {
    'admin-footer': AdminFooter,
    'admin-header': AdminHeader,
    'admin-aside': AdminAside,
    'modal': Modal
  },
  data () {
    return {
      id: '',
      companyName: '',
      isDestinationComp: false,
      isSourceComp: false,
      orderSeq: '',
      statusCode: '',
      statusTitle: '',
      userGroupId: '',
      userGroupName: '',
      flag: 'C',
      showModal: false
    }
  },
  created () {
    this.setInit({'method': 'GET'})
  },
  methods: {
    ...mapActions({
      setInit: 'apiSysadminCompanyTypeMaps'
    }),
    fnModify (item) {
      this.id = item.id
      this.companyName = item.companyName
      this.isDestinationComp = item.isDestinationComp
      this.isSourceComp = item.isSourceComp
      this.orderSeq = item.orderSeq
      this.statusCode = item.statusCode
      this.statusTitle = item.statusTitle
      this.userGroupId = item.userGroupId
      this.userGroupName = item.userGroupName
      this.flag = 'U'
      this.showModal = true
    },
    save () {
      if (this.orderSeq === '' || this.companyName === '' || this.userGroupId === '') {
        alert('필수값을 입력해주세요.')
        return
      }
      if (this.flag === 'U') { // 수정일 경우
        const params = {
          'id': this.id,
          'companyName': this.companyName,
          'destinationComp': this.isDestinationComp,
          'groupId': this.userGroupId,
          'orderSeq': this.orderSeq,
          'sourceComp': this.isSourceComp,
          'status': this.statusCode,
          'method': 'PATCH'
        }
        this.$store.dispatch('apiSysadminCompanyTypeMaps', params)
      } else { // 생성일 경우
        const params = {
          'companyName': this.companyName,
          'destinationComp': this.isDestinationComp,
          'groupId': this.userGroupId,
          'orderSeq': this.orderSeq,
          'sourceComp': this.isSourceComp,
          'method': 'POST'
        }
        this.$store.dispatch('apiSysadminCompanyTypeMaps', params)
      }
      // this.initValues()
    },
    cancle () {
      this.initValues()
    },
    initValues () {
      this.id = ''
      this.companyName = ''
      this.isDestinationComp = ''
      this.isSourceComp = ''
      this.orderSeq = ''
      this.statusCode = ''
      this.statusTitle = ''
      this.userGroupId = ''
      this.userGroupName = ''
      this.flag = 'C'
      this.showModal = false
    }
  },
  computed: {
    ...mapGetters(['getSysadminCompanyTypeMaps', 'getStatuses', 'getGroupsCombo'])
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/AdminCompanyAuth.vue